jQuery(document).ready(function($) {
  $('[data-open="incentive-featured"]').on('click', function() {
    var targetModal = $('#' + $(this).data('open'))
    var plotPrice = targetModal.data('plotPrice')

    targetModal
      .find('#price_5 text')
      .html('&pound;' + addCommas(getNicePercents(plotPrice, 5)))
    targetModal
      .find('#price_20 text')
      .html('&pound;' + addCommas(getNicePercents(plotPrice, 20)))
    targetModal
      .find('#price_75 text')
      .html('&pound;' + addCommas(getNicePercents(plotPrice, 75)))
  })

  function getNicePercents(input, percent) {
    if (!$.isNumeric(input) || !$.isNumeric(percent)) return
    var output = input * (percent / 100)
    output = Math.round(output * 100) / 100
    output = output.toFixed(2)
    return output
  }
  function addCommas(nStr) {
    nStr += ''
    var x = nStr.split('.')
    var x1 = x[0]
    var x2 = x.length > 1 ? '.' + x[1] : ''
    var rgx = /(\d+)(\d{3})/
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }
    return x1 + x2
  }

  $('.single-harron_plots .button.accordion-title').text('Read more')
})
 